import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function auditMaterialConfigGetByCountry(countryCode) { return axios.post(`${base.url}/business/auditMaterialConfig/getByCountry`, qs.stringify({ countryCode })) }
export function auditMaterialConfigSave(data) { return axios.post(`${base.url}/business/auditMaterialConfig/save`, qs.stringify(data)) }
export function auditMaterialConfigCountries() { return axios.post(`${base.url}/business/auditMaterialConfig/countries`) }
export function auditMaterialConfigDelete(countryCode) { return axios.post(`${base.url}/business/auditMaterialConfig/delete`, qs.stringify({ countryCode })) }
